import React from 'react';
import { BoxTitle, BoxSubTitle } from './boxTitle.style';
import { Tooltip } from 'antd';

export default props => {
  return (
    <div id={props.id && props.id} style={{ width: "auto" }}>
      {props.title ? (
        <Tooltip title={props.showTitleTooltip ? props.title : ""} placement='topLeft'>
        <BoxTitle style={props.titleStyle}> {props.title} </BoxTitle>
        </Tooltip>
      ) : (
        ''
      )}
      {props.subtitle ? (
        <Tooltip title={props.showSubtitleTooltip ? props.subtitle : ""} placement='topLeft'>
          {!props.tootipText && <BoxSubTitle className={props.tootipText} style={props.subTitleStyle}> {props.subtitle} </BoxSubTitle>}

          {props.tootipText && <div className={props.className}>
            <BoxSubTitle style={props.subTitleStyle}> {props.subtitle} </BoxSubTitle>
            <BoxSubTitle className="tooltiptext"> {props.subtitle} </BoxSubTitle>
          </div>}
        </Tooltip>
      ) : (
        ''
      )}
       {props.subtitle2 ? (
        <BoxSubTitle className="isoBoxSubTitle" style={{ ...props.subTitle2Style }}> {props.subtitle2} </BoxSubTitle>
      ) : (
        ''
      )}
    </div>
  );
};
